<ts-searchable-selector
  [loaded]="loaded"
  [options]="options"
  [selected]="selected"
  [searchTerm]="searchTerm"
  [totalAvailable]="totalAvailable"
  [ariaLabel]="ariaLabel"
  [noItemsMessage]="noItemsMessage"
  dataCy="select-workspace"
  (selectedChange)="onSelectionChanged($event)"
  (added)="onAdded($event)"
  (removed)="onRemoved($event)"
  (searchTermChanged)="onSearchTermChanged($event)"
  (lastItemReached)="onLastItemReached()"
  (selectAllAcrossPages)="selectAllAcrossPages.emit()"
></ts-searchable-selector>
